import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ica-navy/40 focus-visible:ring-offset-1 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-ica-gold-light text-white font-semibold shadow hover:bg-ica-gold hover:text-white active:bg-ica-gold-dark active:text-white",
        accent:
          "bg-ica-gold text-white shadow hover:bg-ica-gold-dark hover:text-white active:bg-ica-gold-dark",
        destructive:
          "bg-red-600 text-white shadow-sm hover:bg-red-700 active:bg-red-800",
        outline:
          "border border-ica-navy bg-white text-ica-navy shadow-sm hover:bg-ica-navy hover:text-white active:bg-ica-navy-dark active:text-white",
        secondary:
          "bg-ica-cream text-ica-navy shadow-sm hover:bg-ica-cream/70",
        ghost: "text-ica-navy hover:bg-ica-navy/5",
        link: "text-ica-navy underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
